import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// context
import { MenuContext } from 'context/menuContext';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import CardEvent from 'components/event/cardEvent';
import './home.scss';

const EventHome = ({ blogs, events, lists = [], onlyEvents = false }) => {
  const { t } = useTranslation(['home', 'backoffice']);
  const { blogCategories } = useContext(MenuContext);
  const blogCategoriesResume = Array.isArray(blogCategories) ? blogCategories?.slice(0, 3) : [];
  const { assignedLibrary } = useAssignedLibrary();

  return (
    <>
      {events.length > 0 && (<div className="homeContainer p-2 mb-3">
        <div className="containerPosts">
          <div className="aside-title">
            <Link className="homeContainer-title" to={`/${assignedLibrary}/agenda/`}>{t('schedule')}</Link>
          </div>
          {events.map((item, i) => (
            <CardEvent event={item} key={i} />
          ))}
        </div>
      </div>
      )}

      {!onlyEvents && blogCategoriesResume?.length > 0 && (<div className="homeContainer p-2 mb-3">
        <div className="aside-title mb-2">
          <Link className="homeContainer-title" to={`/${assignedLibrary}/blog`}>{t('exports.articles', { ns: 'backoffice' })}</Link>
        </div>
        <div className="blogCategories">
          {blogCategoriesResume?.map((cat, indx) => {
            return (
              <Link to={`/${assignedLibrary}/blog/${cat.id}/${cat.slug}/`} key={cat.id}>
                {cat.last_post_image ? (
                  <img className="mt-3 circle-border" src={cat.last_post_image} alt={`Categories aside pic ${indx + 1}`} />
                ) : (
                  <div
                    className="mt-3 circle-border rounded-circle d-flex align-items-center justify-content-center"
                  >
                    <svg height="80" width="80" xmlns="http://www.w3.org/2000/svg">
                      <circle r="40" cx="40" cy="40" />
                    </svg>
                  </div>
                )}
                <p>{cat.name}</p>
              </Link>
            );
          })}
        </div>
      </div>)}

      {!onlyEvents && lists.length > 0 && (<div className="homeContainer p-2">
        <div className="aside-title mb-2">
          <Link className="homeContainer-title" to={"/"}>{t('listas')}</Link>
        </div>
        <div className="aside-lists">
          {lists?.map((item, index) => {
            const data = { list: item.id }
            return (
              <Link
                key={`eventLink#${index}`}
                state={ data }
                className="aside-lists-item d-block px-2 mt-2"
                to={`/${assignedLibrary}/lista/products_by_list?title=${encodeURIComponent(item?.nombre)}`}
              >
                {item.nombre}
              </Link>
            )
          })}
        </div>
      </div>
      )}
    </>
  );
};

EventHome.propTypes = {
  blogs: PropTypes.array,
  events: PropTypes.array,
  lists: PropTypes.array,
  onlyEvents: PropTypes.bool,
};

export default EventHome;
